import { Box, styled, Typography } from '@mui/material';
import Spacing from 'components/Spacing';

const Title = styled('h4')(({ theme }) => ({
  backgroundColor: theme.palette.background.light,
  padding: theme.spacing(3, 4),
  height: theme.spacing(10),

  margin: 0,
}));

const Content = styled(Spacing)(({ theme }) => ({
  padding: theme.spacing(5, 4),
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '2px',
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.1), transparent)',
  },
}));

const Footer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.light,
  height: theme.spacing(10),
}));

const EarnoutInfo: React.FC = () => {
  return (
    <Box>
      <Title>Accounts transaction (earnout consideration)</Title>
      <Content>
        <Typography>
          Earnout inputs are for record-keeping only and will not be added to
          the General Ledger.
        </Typography>
      </Content>
      <Footer></Footer>
    </Box>
  );
};

export default EarnoutInfo;
